import { List } from "lodash";


export interface IPersonalData {
    CompanyId: number,
    CompanyName: string,
    INN: string,
    Address: string,
    PassportSeries: string,
    PassportDate: Nullable<Date>,
    PassportPlace: string,
    FirstName: string,
    LastName: string,
    MiddleName: string
    OGRNIP: string,
    BirthDay: Nullable<Date>,
    RegAddress: string,
    FactAddress: string,
    OGRN: string,
    CompanyTypeId: number,
    AdditionalInfo: string,
    StatusChecking: number,
    DeclineReason: string,
    Documents: Array<IdocumentModel>,
    RequiredDocumentsType: Array<DocumentType>
}

export interface IdocumentModel {
    Id: number,
    DocDBId: Nullable<number>,
    Name: string,
    Comment: string,
    DocumentTypeId: number,
    CreationDate: Date,
    IsSignatureVendor: boolean,
    IsSignatureWinner: boolean,
    DateSignVendor: string,
    DateSignWinner: string,
    SignStatusId: Nullable<number>,
    SignStatusDescription: string,
    DocumentTypeDescription: string,
    CurrentUserCanSign: boolean,
    SignatureLink: string,
    Signature: string,
    SignedData: string,
    DocumentLink: string
    LotId: String,
    LotName: String,
    LotUrl: String,
    CompanyId: String,
    CompanyName: String,
    CompanyProfileUrl: String,
    OwnerAccountId: Number,
    CanSignCurrentUser: boolean,
    DocumentBase64: String,
    IsEditType?: boolean,
    IsEditName?: boolean,
    IsEditComment?: boolean,
    File?: File,
    TempDocId?: any
}

export enum AccountStatus {
    Active = 1,
    WaitingConfirmation = 2,
    RegistrationDeclined = 3,
    Blocked = 4,
    New = 5,
    WaitingCertificateConfirmation = 6,
    AccessDenied = 7,
    InvalidCertificate = 8,
    NotAccepted = 9,
    WaitingConfirmPersonalData = 10,
    PersonalDataComfirmed = 11
}

export var AccountStatusDescription: { [key: AccountStatus]: string; } = {};
AccountStatusDescription[AccountStatus.Active] = "Активен";
AccountStatusDescription[AccountStatus.WaitingConfirmation] = "Ожидает подтверждения";
AccountStatusDescription[AccountStatus.Blocked] = "Заблокирован";
AccountStatusDescription[AccountStatus.New] = "Новый";
AccountStatusDescription[AccountStatus.WaitingCertificateConfirmation] = "Ожидает подтверждения сертификата";
AccountStatusDescription[AccountStatus.AccessDenied] = "Вход в систему запрещен";
AccountStatusDescription[AccountStatus.InvalidCertificate] = "Некорректный сертификат";
AccountStatusDescription[AccountStatus.NotAccepted] = "Не принято";
AccountStatusDescription[AccountStatus.RegistrationDeclined] = 'В регистрации отказано';
AccountStatusDescription[AccountStatus.WaitingConfirmPersonalData] = 'Ожидание подтверждения персональных данных';
AccountStatusDescription[AccountStatus.PersonalDataComfirmed] = 'Персональные данные подтверждены';


export enum LegalRequestStatusChecking {
    NoStatus = 0,
    ReadyToCheck = 1,
    Adopted = 2,
    CheckFailed = 3,
    Draft = 4
}

export var LegalRequestStatusCheckingDescription: { [key: LegalRequestStatusChecking]: string; } = {};
LegalRequestStatusCheckingDescription[LegalRequestStatusChecking.NoStatus] = "Нет статуса";
LegalRequestStatusCheckingDescription[LegalRequestStatusChecking.ReadyToCheck] = 'На проверке';
LegalRequestStatusCheckingDescription[LegalRequestStatusChecking.Adopted] = 'Принят';
LegalRequestStatusCheckingDescription[LegalRequestStatusChecking.CheckFailed] = 'Не прошел проверку';
LegalRequestStatusCheckingDescription[LegalRequestStatusChecking.Draft] = 'Черновик';

export enum DocumentType {
    SystemDocument = 1,
    TechDocumentation = 2,
    PurchaseNotice = 3,
    AdvanceAgreement = 4,
    DebtorGoodsSaleAgreement = 5,
    CopyOfExtractFromCompanyRegister = 6,
    CopyOfExtractFromIndividualEntrepreneurRegister = 7,
    CopyOfFoundingDocument = 8,
    CopyOfCertificateOfIdentity = 9,
    RegistrationDocumentsTranslation = 10,
    ChiefPermissionsDocuments = 11,
    ApprovalDecisionCopy = 12,
    ApplicantInterest = 13,
    // ArbitrationAdministratorCapitalContribution = 14,
    ApplicantInformation = 15,
    // SROAUInformation = 16, //
    CertificateOfRegistrationWithTheTaxAuthority = 17,
    BidsReport = 18,
    PartyDecisionProtocol = 19,
    ChoiceOfWinnerProtocol = 20,
    WinnerProtocol = 21,
    AuthorityDocument = 22,
    RetenderNotice = 23,
    RetenderProtocol = 24,
    RetenderEnvelopeProtocol = 25,
    RetenderChoiceOfWinnerProtocol = 26,
    PurchaseApplication = 27,
    ResultNotice = 28,
    ArchivesPartyDecisionProtocol = 29,
    CertificateOfRegistrationINN = 30,
    Image = 31,
    ClosedPurchaseParticipationComplience = 32,
    System = 33,
    Other = 34,
    ProtocolAIS_ERKT = 35,
    AuctionDecision = 36,
    TradeProtocol = 37,
    LotProtocol = 38,
    Agreement = 39,
    PurchaseParticipantsProtocol = 40,
    AuctionProtocol = 41,
    BusinessAgreement = 42,
    DebtorFeeActComWorks = 43,
    DebtorFeeInvoice = 44,
    DebtorFee = 45,
    DebtorFeeCover = 46,
    ReturnRegistrySingle = 47,
    ReturnRegistryMultiple = 48,
    PaymentDocument = 49,
    ContractOfSale = 50,
}

export var documentTranslations: { [key: DocumentType]: string; } = {}; 
documentTranslations[DocumentType.SystemDocument] = "Системный документ";
documentTranslations[DocumentType.TechDocumentation] = "Техническая документация";
documentTranslations[DocumentType.PurchaseNotice] = "Уведомление о закупке";
documentTranslations[DocumentType.AdvanceAgreement] = "Договор авансирования";
documentTranslations[DocumentType.DebtorGoodsSaleAgreement] = "Договор продажи имущества должника";
documentTranslations[DocumentType.CopyOfExtractFromCompanyRegister] = "Копия выписки из реестра компаний";
documentTranslations[DocumentType.CopyOfExtractFromIndividualEntrepreneurRegister] = "Копия выписки из реестра ИП";
documentTranslations[DocumentType.CopyOfFoundingDocument] = "Копия учредительного документа";
documentTranslations[DocumentType.CopyOfCertificateOfIdentity] = "Копия удостоверения личности";
documentTranslations[DocumentType.RegistrationDocumentsTranslation] = "Перевод регистрационных документов";
documentTranslations[DocumentType.ChiefPermissionsDocuments] = "Документы разрешения руководителя";
documentTranslations[DocumentType.ApprovalDecisionCopy] = "Копия решения об утверждении";
documentTranslations[DocumentType.ApplicantInterest] = "Заинтересованность заявителя";
documentTranslations[DocumentType.ApplicantInformation] = "Информация о заявителе";
documentTranslations[DocumentType.CertificateOfRegistrationWithTheTaxAuthority] = "Свидетельство о постановке на учет в налоговой";
documentTranslations[DocumentType.BidsReport] = "Отчет о торгах";
documentTranslations[DocumentType.PartyDecisionProtocol] = "Протокол решения стороны";
documentTranslations[DocumentType.ChoiceOfWinnerProtocol] = "Протокол выбора победителя";
documentTranslations[DocumentType.WinnerProtocol] = "Протокол победителя";
documentTranslations[DocumentType.AuthorityDocument] = "Документ полномочий";
documentTranslations[DocumentType.RetenderNotice] = "Уведомление о повторных торгах";
documentTranslations[DocumentType.RetenderProtocol] = "Протокол повторных торгов";
documentTranslations[DocumentType.RetenderEnvelopeProtocol] = "Протокол вскрытия конвертов повторных торгов";
documentTranslations[DocumentType.RetenderChoiceOfWinnerProtocol] = "Протокол выбора победителя повторных торгов";
documentTranslations[DocumentType.PurchaseApplication] = "Заявка на покупку";
documentTranslations[DocumentType.ResultNotice] = "Уведомление о результатах";
documentTranslations[DocumentType.ArchivesPartyDecisionProtocol] = "Протокол решения стороны (архив)";
documentTranslations[DocumentType.CertificateOfRegistrationINN] = "Свидетельство о регистрации ИНН";
documentTranslations[DocumentType.Image] = "Изображение";
documentTranslations[DocumentType.ClosedPurchaseParticipationComplience] = "Соответствие участия в закрытых закупках";
documentTranslations[DocumentType.System] = "Система";
documentTranslations[DocumentType.Other] = "Другое";
documentTranslations[DocumentType.ProtocolAIS_ERKT] = "Протокол АИС ЕРКТ";
documentTranslations[DocumentType.AuctionDecision] = "Решение аукциона";
documentTranslations[DocumentType.TradeProtocol] = "Торговый протокол";
documentTranslations[DocumentType.LotProtocol] = "Протокол лота";
documentTranslations[DocumentType.Agreement] = "Соглашение";
documentTranslations[DocumentType.PurchaseParticipantsProtocol] = "Протокол участников закупки";
documentTranslations[DocumentType.AuctionProtocol] = "Протокол аукциона";
documentTranslations[DocumentType.BusinessAgreement] = "Бизнес-соглашение";
documentTranslations[DocumentType.DebtorFeeActComWorks] = "Акт выполненных работ по вознаграждению должника";
documentTranslations[DocumentType.DebtorFeeInvoice] = "Счет-фактура на вознаграждение должника";
documentTranslations[DocumentType.DebtorFee] = "Вознаграждение должника";
documentTranslations[DocumentType.DebtorFeeCover] = "Сопроводительный документ на вознаграждение должника";
documentTranslations[DocumentType.ReturnRegistrySingle] = "Реестр возвратов (одиночный)";
documentTranslations[DocumentType.ReturnRegistryMultiple] = "Реестр возвратов (множественный)";
documentTranslations[DocumentType.PaymentDocument] = "Платежный документ";
documentTranslations[DocumentType.ContractOfSale] = "Договор купли-продажи";
